<app-news-layout
  title="AAM Toolkit"
  img="/assets/img/game/toolkit-bg.svg"
  [smaller]="true"
  (closeClick)="onCloseClick()"
>
  <div class="wrap" *ngIf="aam$ | async as aam">
    <div class="text">
      <div class="bold">AAM:</div>
      <div>Please select one of the three amounts below and then click <span class="bold">Confirm</span>.</div>
    </div>
    <div class="boxes">
      <div class="box" *ngFor="let x of [50, 100, 150]">
        <div class="sum" [ngClass]="aam.aam_incentives !== x && aam.is_aam_selected ? 'gray' : ''">£{{x}}</div>
        <img
          *ngIf="aam.aam_incentives === x && !aam.is_aam_selected"
          src="/assets/img/game/switch-green.svg"
          (click)="assign(0)"
        >
        <img
          *ngIf="aam.aam_incentives === x && aam.is_aam_selected"
          src="/assets/img/game/switch-green.svg"
        >
        <img
          *ngIf="aam.aam_incentives !== x && !aam.is_aam_selected"
          src="/assets/img/game/switch-cross.svg"
          (click)="assign(x)"
        >
        <img
          *ngIf="aam.aam_incentives !== x && aam.is_aam_selected"
          src="/assets/img/game/switch-blocked.svg"
        >
      </div>
    </div>
    <app-button-bg
      *ngIf="aam.aam_incentives === 0 || aam.is_aam_selected" class="btn"
      img="/assets/img/game/begin-bg-gray.svg"
      [disabled]="true"
    >
      <div class="btn-inside">Confirm</div>
    </app-button-bg>
    <app-button-bg
      *ngIf="aam.aam_incentives !== 0 && !aam.is_aam_selected" class="btn"
      img="/assets/img/game/begin-bg.svg"
      (click)="confirm()"
    >
      <div class="btn-inside">Confirm</div>
    </app-button-bg>
  </div>
</app-news-layout>
